export function SET_LOCATIONS (state, data) {
    state.locations = data.regions
}